import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useBrandKit } from '../contexts/BrandKitContext';

const { FiLayers, FiAlertTriangle, FiRefreshCw, FiSettings } = FiIcons;

const Header = () => {
  const { refreshBrandKits } = useBrandKit();

  const handleRefresh = (e) => {
    e.preventDefault();
    refreshBrandKits();
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiLayers} className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="text-xl font-bold text-gray-900">Rebrand Studio</span>
              <p className="text-xs text-gray-500">Professional Document Rebranding</p>
            </div>
          </Link>

          <nav className="flex items-center space-x-2">
            <Link
              to="/debug/quick-uploader"
              className="px-4 py-2 text-sm font-medium text-orange-700 bg-orange-50 border border-orange-300 rounded-lg hover:bg-orange-100 transition-colors flex items-center space-x-2"
            >
              <SafeIcon icon={FiAlertTriangle} className="w-4 h-4" />
              <span>Debug Uploads</span>
            </Link>
            <button
              onClick={handleRefresh}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors flex items-center space-x-2"
            >
              <SafeIcon icon={FiRefreshCw} className="w-4 h-4" />
              <span>Refresh</span>
            </button>
            <Link
              to="/brand-kit"
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors flex items-center space-x-2"
            >
              <SafeIcon icon={FiSettings} className="w-4 h-4" />
              <span>Manage Brand Kits</span>
            </Link>
            <Link
              to="/process"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
            >
              <SafeIcon icon={FiLayers} className="w-4 h-4" />
              <span>Process Document</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;